import {isString} from 'ramda-adjunct';

import {isDefined} from 'shared/web';

import {GetChunkFn} from '../types/GetChunkFn';
import {QueueVideoTask} from '../types/QueueVideoTask';
import {QueueVideoTaskJob} from '../types/QueueVideoTaskJob';
import {getFileChunk} from './getFileChunk';

export async function handleUploadChunk(
  task: QueueVideoTask,
  job: QueueVideoTaskJob,
  getChunk: GetChunkFn,
  signal?: AbortSignal
): Promise<{etag: string}> {
  const chunk = await getFileChunk(task, job, getChunk);

  const response = await fetch(job.url, {
    body: chunk,
    method: 'PUT',
    headers: {'content-type': task.mimeType},
    signal,
  });

  const etag = response.headers.get('etag');

  if (isDefined(etag) && isString(etag)) {
    return {etag};
  }
  throw Error('No etag');
}
